import React, { ReactNode } from 'react';

import { Grid } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

interface PropsType {
	label: string;
	value: ReactNode;
	children?: ReactNode;
}

function CourseInfoText({ label, value, children }: PropsType) {
	return (
		<Grid container gap="8px" alignItems="center">
			<MediaTypography variant="body1" variants={{ sm: 'body2' }}>
				{label} -
			</MediaTypography>
			<MediaTypography variant="subtitle1" variants={{ sm: 'subtitle2' }}>
				{value}
			</MediaTypography>
			{children}
		</Grid>
	);
}

export default CourseInfoText;
